<div class="order-container">
  <div class="row">
    <div class="col-lg-8 order-2 order-lg-1">
      <wl-order-fulfillment-container
        [rendering]="rendering()"
        [existingCustomerChecked]="existingCustomerChecked()"
      ></wl-order-fulfillment-container>
    </div>
    <div
      class="col-lg-4 order-lg-2"
      [class]="orderOverviewBottomMobile() ? 'order-3' : 'order-1'"
    >
      @if (rendering(); as rendering) {
        <div
          sc-placeholder
          name="order-overview-card"
          class="sticky-lg-top sticky-lg-offset mb-2"
          [rendering]="rendering"
          [inputs]="
            jssPlatformService.isEditorActive()
              ? xpMockOrder
              : {
                  offer: offer(),
                  durationTitle: duration()?.durationTitle,
                  consumptionValuesVM: consumptionValuesVM(),
                  electricityOverview: electricityOverview(),
                  gasOverview: gasOverview(),
                }
          "
          [outputs]="outputs"
        ></div>
      }
    </div>
  </div>
</div>
